import { apiClient } from './apiClient';

export interface ChannelsBaseUrl {
  id: string;
  baseUrl: string;
  createdDate: string;
  updatedDate: string;
  createdBy: string;
  updatedBy: string;
}

export interface UpdateChannelsBaseUrlRequest {
  baseUrl: string;
}

export interface ChannelsBaseUrlResponse {
  success: boolean;
  message?: string;
  channelsBaseUrl: ChannelsBaseUrl;
}

export const channelsBaseUrlService = {
  /**
   * Get the current channels base URL configuration
   */
  async getChannelsBaseUrl(): Promise<ChannelsBaseUrlResponse> {
    return apiClient.get<ChannelsBaseUrlResponse>('/channels-base-url');
  },

  /**
   * Update the channels base URL configuration
   */
  async updateChannelsBaseUrl(baseUrl: string): Promise<ChannelsBaseUrlResponse> {
    const request: UpdateChannelsBaseUrlRequest = { baseUrl };
    return apiClient.put<ChannelsBaseUrlResponse>('/channels-base-url', request);
  },
};
